module.exports = __webpack_public_path__ + "img/shrimp-2.ccd35a5f.png";